// Function to get the current sound state from localStorage
export const getSoundState = () => {
  return JSON.parse(localStorage.getItem("isSoundOn") ?? "true");
};

// Function to set the sound state in localStorage
export const setSoundOn = (value) => {
  localStorage.setItem("isSoundOn", JSON.stringify(value));
};

const playBeep = () => {
  // Always read the current state from localStorage - no caching!
  const isSoundEnabled = getSoundState();
  
  console.log("🔊 Sound enabled:", isSoundEnabled); // Debug log
  
  if (!isSoundEnabled) {
    console.log("🔇 Sound is OFF - skipping beep"); // Debug log
    return;
  }

  try {
    const audio = new Audio("/beep1.mp3");
    audio.volume = 0.6;
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch((err) => {
        console.log("Beep playback rejected:", err);
      });
    }
  } catch (err) {
    console.error("Beep sound error:", err);
  }
};

export default playBeep;
